import { useEffect, useRef, useState } from "react";
// import { CustomButton } from "../Components/CustomButton/Button";
import {
  AvatarUser,
  ButtonBackPage,
  ButtonContantUs,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSaveAvatarUser,
  ButtonSecurity,
  ButtonUpload,
  ButtonUploadAvatar,
  ContainerButton,
  ContainerMainInfoPage,
  ErrorMessage,
  FormNewEmailUser,
  FormNewEmailUserButton,
  FormNewEmailUserInput,
  FormNewNameUser,
  FormNewNameUserButton,
  FormNewNameUserInput,
  HeaderMainInfo,
  Languages,
  MainTitlePage,
  NameUser,
  NicNameUserColor,
  TitlePage,
  UpdateDataUserContainer,
} from "./MainInfoStyles.styled";

import { toast } from "react-toastify";
import { ButtonBackPageIcon, UploadNewAvatar } from "./Icons/Icons";
import { NavLink, useNavigate } from "react-router-dom";
import { ModelWindow } from "../../Components/ModelWindow/ModelWindow";
import { Logout } from "../../Components/ModelWindows/Logout/Logout";
import {
  updateUserAccount,
  updateUserAccountEmail,
  updateUserAccountName,
  updateUserAvatar,
} from "../../Redux/Auth/operations";
import { AvatarUserView } from "./AvatarUserView/AvatarUserView";
import { AvatarUserViewModel } from "./AvatarUserViewModel/AvatarUserViewModel";
import { useAppDispatch } from "../../Redux/store";
import { useLanguageContext } from "../../Components/Languages/Langs/LanguageContext";
import { ButtonLogOut } from "../../Components/ModelWindows/Logout/LogOut.styled";
import useAuth from "../../Redux/useAuth";
// import { ModelUpdateQRCode } from "../../Components/ModelUpdateQRCode/ModelUpdateQRCode";

/*
  1. After updated name, display new name in red color (change on green succes)
  2. After updated email, display in red color (change on green success)
  3. In console running error after success updated
*/

export const MainInfoPage = () => {
  const navigate = useNavigate();
  const { user, isRefreshing } = useAuth();
  const { t } = useLanguageContext();
  const dispatch = useAppDispatch();

  // doesn't work handleClick
  const handleClick = () => {
    if (isRefreshing) return; // чекаємо
    const userName = user?.name?.toLowerCase();

    if (userName) {
      navigate(`/home-page/${userName}`);
    } else {
      // НЕ кидаємо на sign-in одразу — даємо шанс user підтягнутись
      setTimeout(() => {
        const refreshedName = user?.name?.toLowerCase();
        navigate(refreshedName ? `/home-page/${refreshedName}` : "/sign-in");
      }, 100);
    }
  };

  const [openModelLogOut, setOpenModelLogOut] = useState<boolean>(false);
  const [showLogOut, setShowLogOut] = useState<boolean>(false);

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };

  // avatar user

  const [openModelAvatar, setOpenModelAvatar] = useState<boolean>(false);
  const [showAvatar, setShowAvatar] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  const openModelWindow = () => {
    setShowAvatar(true);
    setTimeout(() => setOpenModelAvatar(true), 0);
  };

  const closeModelWindow = () => {
    setOpenModelAvatar(false);
    setTimeout(() => setShowAvatar(false), 250);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);

      // одразу оновлюємо локальний прев’ю
      const localUrl = URL.createObjectURL(file);
      setAvatarUrl(localUrl);
    }
  };

  const handleAvatarUploadClick = async () => {
    if (!selectedFile) {
      toast.warn(t("privateTraslate.updateDataUserPageUploadError"));
      return;
    }

    try {
      await dispatch(
        updateUserAvatar({
          avatarUser: selectedFile!,
        }),
      ).unwrap();
      setAvatarUrl(avatarUrl);

      toast.success(t("privateTraslate.updateDataUserPageUploadSuccess"));
    } catch (error) {
      console.error(
        typeof error === "string" ? error : "Error uploading avatar:",
      );
      toast.error(t("privateTraslate.updateDataUserPageUploadErrorServer"));
    }
  };

  // update name user

  interface ErrorFormName {
    name?: string;
  }

  const [hasTriedSubmit, setHasTriedSubmit] = useState<boolean>(false);
  const [newNameUser, setNewNameUser] = useState<string | null>(null);
  const [checkFormErros, setCheckFormErrors] = useState<ErrorFormName>({});

  const checkFormNewName = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);

    try {
      await dispatch(
        updateUserAccountName({
          name: newNameUser?.trim() || "",
        }),
      ).unwrap();
      dispatch(updateUserAccount());
      toast.success(
        `${t("privateTraslate.updateDataUserPageNameSuccess")} ${newNameUser}`,
      );
    } catch (error: unknown) {
      console.log("Unwrapped error:", error);

      if (typeof error === "object" && error !== null) {
        const typedError = error as ErrorFormName;
        setCheckFormErrors(typedError);
      } else {
        toast.error(t("privateTraslate.updateDataUserPageNameErrorServer"));
      }
    }
  };

  interface EmailUserError {
    email?: string;
  }

  const [newUserEmail, setNewUserEmail] = useState<string | null>(null);
  const [checkFormEmailErros, setCheckFormEmailErrors] =
    useState<EmailUserError>({});

  const checkFormEmail = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);

    try {
      await dispatch(
        updateUserAccountEmail({
          email: newUserEmail?.trim() || "",
        }),
      ).unwrap();

      toast.success(t("privateTraslate.updateDataUserPageEmailSuccess"));
    } catch (error: unknown) {
      console.log("Unwrapped error:", error);

      if (typeof error === "object" && error !== null) {
        const typedError = error as EmailUserError;
        setCheckFormEmailErrors(typedError);
      } else {
        toast.error(t("privateTraslate.updateDataUserPageEmailErrorServer"));
      }
    }
  };

  useEffect(() => {
    return () => {
      if (avatarUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(avatarUrl);
      }
    };
  }, [avatarUrl]);
  return (
    <>
      <HeaderMainInfo>
        <ButtonBackPage
          to="#"
          onClick={(e) => {
            e.preventDefault();
            handleClick();
          }}
        >
          <ButtonBackPageIcon />
        </ButtonBackPage>

        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>

        <TitlePage>{t("privateTraslate.updateDataUserPageTitle")}</TitlePage>
      </HeaderMainInfo>

      <ContainerMainInfoPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
            <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
          </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonContantUs>
              {t("privateTraslate.ButtonCredit")}
            </ButtonContantUs>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>

        <MainTitlePage>
          {t("privateTraslate.updateDataUserPageTitle")}
        </MainTitlePage>
        <UpdateDataUserContainer>
          {/* add loader when uploading avatar */}
          {/* add model window when account delete, after redirectTo on welcome page */}
          <AvatarUser>
            <ButtonUpload
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
            {/* add error for upload avatar (sizes) */}
            <ButtonUploadAvatar onClick={() => fileInputRef.current?.click()}>
              <UploadNewAvatar />
            </ButtonUploadAvatar>
            <AvatarUserView
              newAvatarUser={avatarUrl ?? user?.avatarUser ?? undefined}
              onClick={openModelWindow}
            />
          </AvatarUser>

          <ButtonSaveAvatarUser onClick={handleAvatarUploadClick}>
            {t("privateTraslate.updateDataUserPageUploadButton")}
          </ButtonSaveAvatarUser>

          {showAvatar && (
            <ModelWindow onClose={closeModelWindow} isOpen={openModelAvatar}>
              <AvatarUserViewModel
                newAvatarUser={avatarUrl ?? user?.avatarUser ?? undefined}
                onClose={closeModelWindow}
              />
            </ModelWindow>
          )}

          <FormNewNameUser onSubmit={checkFormNewName}>
            <FormNewNameUserInput
              type="text"
              placeholder={t("privateTraslate.updateDataUserPageNameInput")}
              value={newNameUser || ""}
              onChange={(e) => setNewNameUser(e.target.value)}
            />
            <ErrorMessage
              className={
                checkFormErros.name && hasTriedSubmit ? "error-animation" : ""
              }
            >
              {checkFormErros.name}
            </ErrorMessage>
            <FormNewNameUserButton type="submit">
              {t("privateTraslate.updateDataUserPageNameSave")}
            </FormNewNameUserButton>
          </FormNewNameUser>

          <FormNewEmailUser onSubmit={checkFormEmail}>
            <FormNewEmailUserInput
              type="text"
              value={newUserEmail || ""}
              onChange={(e) => setNewUserEmail(e.target.value)}
              placeholder={t("privateTraslate.updateDataUserPageEmailInput")}
            />
            <ErrorMessage
              className={
                checkFormEmailErros.email && hasTriedSubmit
                  ? "error-animation"
                  : ""
              }
            >
              {checkFormEmailErros.email}
            </ErrorMessage>
            <FormNewEmailUserButton type="submit">
              {t("privateTraslate.updateDataUserPageEmailSave")}
            </FormNewEmailUserButton>
          </FormNewEmailUser>
          {/* add status email user (confirmed or not) */}

          {showLogOut && (
            <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
              <Logout onClose={closeLogOut} />
            </ModelWindow>
          )}
        </UpdateDataUserContainer>
      </ContainerMainInfoPage>

      {/* {showConfirmEmail && (
        <ModelUpdateQRCode onClose={closeConfirmEmail} isOpen={isOpenModal}>
          <ConfirmEmailModel
            onNext={() => {
              closeConfirmEmail(); // закриваємо ConfirmEmail
              setTimeout(() => openAddQRCode(), 300); // відкриваємо AddQRCode
            }}
          />
        </ModelUpdateQRCode>
      )} */}
    </>
  );
};
